import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { AutocompleteArrayInput, BooleanInput, NumberInput, SelectInput, TextInput } from 'react-admin';
import { FormDataConsumer } from 'react-admin';
import { required } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import AdUnitTypeChoices from '../StaticData/AdUnitTypeChoices';
import CanViewBordeauxSettings from '../Helpers/CanViewBordeauxSettings';
import Positions from '../StaticData/Positions';
import SizeMappings from './SizeMappings';

const styles = createStyles({
  dropdown: {
    minWidth: 120
  },
  order: {
    width: 100
  }
});

const ValidateRequired = required();

type Props = {
  adSizes: string[],
  classes: any,
  item: string,
  record: any
};

const AdUnitTabSettings = (props: Props) => (
  <div style={{ padding: 20 }}>
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 3 }}>
        <Field
          component={TextInput}
          label="Div ID *"
          name={`${props.item}.div_id`}
          options={{ fullWidth: true }}
          source={`${props.item}.div_id`}
          validate={ValidateRequired} />
      </div>
      <div style={{ flex: 1, paddingLeft: 20 }}>
        <Field
          className={props.classes.order}
          component={NumberInput}
          label="Ad Unit Order"
          name={`${props.item}.order`}
          source={`${props.item}.order`} /><br />
      </div>
    </div>

    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}>
        <Field
          choices={Positions}
          component={SelectInput}
          label="Position"
          name={`${props.item}.position`}
          source={`${props.item}.position`} />
      </div>
      <div style={{ flex: 3, paddingLeft: 20 }}>
        <Field
          component={BooleanInput}
          label="ATF"
          name={`${props.item}.atf`}
          source={`${props.item}.atf`}
          style={{ width: 0 }} />
      </div>
    </div>

    <FormDataConsumer>
      {({ formData, ...rest }) => CanViewBordeauxSettings(formData) &&
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1, paddingRight: 15 }}>
            <Field
              choices={AdUnitTypeChoices}
              component={SelectInput}
              label="Ad Unit Type *"
              name={`${props.item}.type`}
              source={`${props.item}.type`} />
          </div>
        </div>
      }
    </FormDataConsumer>

    <Field
      allowEmpty
      choices={props.adSizes}
      className={props.classes.dropdown}
      component={AutocompleteArrayInput}
      label="Ad Sizes"
      name={`${props.item}.sizes`}
      source={`${props.item}.sizes`} /><br /><br />

    <div style={{ display: 'flex' }}>
      <FieldArray
        adSizes={props.adSizes}
        component={SizeMappings}
        name={`${props.item}.size_mappings`}
        record={props.record} />
    </div>
  </div>
);

export default withStyles(styles)(AdUnitTabSettings);



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/AdUnitTabSettings.tsx